
      import { Buffer } from "buffer";
      globalThis.Buffer = Buffer;
      window.Buffer = Buffer;
    